import { actionCreator } from '@ardoq/rxbeach';
import type {
  InitiativeEditValueChangedPayload,
  OpenInitiativeFieldEditPayload,
  UpdateInitiativePayload,
} from './types';

const DOMAIN = '[transformations.initiativePageForm]';

export const initiativeFieldEditOpened =
  actionCreator<OpenInitiativeFieldEditPayload>(
    `${DOMAIN} INITIATIVE_FIELD_EDIT_OPENED`
  );

export const initiativeFieldEditClosed = actionCreator(
  `${DOMAIN} INITIATIVE_FIELD_EDIT_CLOSED`
);

export const initiativeFieldValueChanged =
  actionCreator<InitiativeEditValueChangedPayload>(
    `${DOMAIN} INITIATIVE_FIELD_VALUE_CHANGED`
  );

export const updateInitiativeRequested = actionCreator<UpdateInitiativePayload>(
  `${DOMAIN} UPDATE_INITIATIVE_REQUESTED`
);

export const updateStageRequested = actionCreator<UpdateInitiativePayload>(
  `${DOMAIN} UPDATE_STAGE_REQUESTED`
);
